var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Stellenprofil nicht mehr veröffentlichen",
        size: "lg",
        "ok-text": "Veröffentlichung aufheben",
        "ok-disabled": _vm.unpublishing,
        "ok-loading": _vm.unpublishing,
        "hide-cancel": _vm.unpublishing
      },
      on: {
        ok: _vm.unpublish,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("div", [
        _vm._v(
          "Soll das Stellenprofil wirklich nicht mehr veröffentlicht sein?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2" }, [
        _vm._v(
          "Es kann dadurch von Kandidaten nicht mehr gefunden werden, da dein Stellenprofil in keinen Listen mehr aufscheint."
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }